define([
	"dojo/_base/declare",
	"dijit/form/_RadioButtonMixin",
	"./CheckBox"
], function(declare,_RadioButtonMixin,CheckBox) {

	return declare([CheckBox, _RadioButtonMixin], {
		// allow use of "value" attribute rather than "checked" to be consistent with other widgets
		baseClass: "dijitRadio",
		
		_onClick: function(/*Event*/ e){
			if(!this.disabled && !this.required && this.checked) {
				//adds ablity to unselect checked value and resets the radio button
				this.checked = false;
			}
			return this.inherited(arguments);
		}
	});
});